<template>
  <div class="action-key-container">
    <label class="tb-label">
      Hot Keys
    </label>

    <p>
      Trigger by pressing buttons or using keyboard shortcuts
    </p>

    <div class="action-keys">
      <action-key
        v-for="(action, index) in panel.settings.animations"
        :key="index"
        :action="action"
        :production_context="production_context"
        :data-test="`panel-editor-action-${action.hotkey.toLowerCase()}`"
      />
    </div>
  </div>
</template>

<script>
import ActionKeyComponent from './ActionKey.vue';
import EditingMixins from '../../../mixins/editing-mixins';

export default {
  props: ['option', 'panel', 'production_context'],
  mixins: [EditingMixins],
  components: {
    'action-key': ActionKeyComponent,
  },
};
</script>
